{
  "Accessibility Menu": "அணுகல்தன்மை மெனு",
  "Reset settings": "அமைப்புகளை மீட்டமை",
  "Close": "மூடு",
  "Content Adjustments": "உள்ளடக்க மாற்றங்கள்",
  "Adjust Font Size": "எழுத்து அளவை சரிசெய்",
  "Highlight Title": "தலைப்பை முன்னிலைப்படுத்து",
  "Highlight Links": "இணைப்புகளை முன்னிலைப்படுத்து",
  "Readable Font": "படிக்கக்கூடிய எழுத்துரு",
  "Color Adjustments": "நிற மாற்றங்கள்",
  "Dark Contrast": "கருமை மாறுபாடு",
  "Light Contrast": "ஒளி மாறுபாடு",
  "High Contrast": "அதிக மாறுபாடு",
  "High Saturation": "அதிக செறிவு",
  "Low Saturation": "குறைந்த செறிவு",
  "Monochrome": "ஒற்றை நிறம்",
  "Protanopia": "புரோட்டனோபியா",
  "Deuteranopia": "டியூட்டரனோபியா",
  "Tritanopia": "ட்ரைட்டனோபியா",
  "Visual & Navigation Aids": "காட்சி மற்றும் வழிசலை உதவிகள்",
  "Additional Tools": "கூடுதல் கருவிகள்",
  "Reading Guide": "வாசிப்பு வழிகாட்டி",
  "Stop Animations": "அசைவூட்டங்களை நிறுத்து",
  "Big Cursor": "பெரிய கர்சர்",
  "Screen Reader": "ஸ்கிரீன் ரீடர்",
  "Hide Images": "படங்களை மறை",
  "Image Tooltips": "பட உதவிக்குறிப்புகள்",
  "Page Structure": "பக்க அமைப்பு",
  "Super Focus": "சூப்பர் ஃபோகஸ்",
  "Magnifier": "உலர்வாடி",
  "Increase Font Size": "எழுத்து அளவை அதிகரி",
  "Decrease Font Size": "எழுத்து அளவை குறை",
  "Letter Spacing": "எழுத்து இடைவெளி",
  "Line Height": "வரி உயரம்",
  "Font Weight": "எழுத்து தடிமன்",
  "Dyslexia Font": "டிஸ்லெக்ஸியா எழுத்துரு",
  "Language": "மொழி",
  "Open Accessibility Menu": "அணுகல்தன்மை மெனுவைத் திற",
  "Accessibility Profiles": "அணுகல்தன்மை சுயவிவரங்கள்",
  "Seizure Safe Profile": "வலிப்பு-பாதுகாப்பு சுயவிவரம்",
  "Stops animations and reduces color saturation.": "அசைவூட்டங்களை நிறுத்தி நிற செறிவை குறைக்கிறது.",
  "Blind Profile": "பார்வை இல்லாதோர் சுயவிவரம்",
  "Activates the screen reader for auditory navigation.": "ஸ்கிரீன் ரீடரை செயல்படுத்தி ஒலி வழிசலை செய்கிறது.",
  "Visually Impaired Profile": "பார்வை குறைபாடுள்ளோர் சுயவிவரம்",
  "Enhances contrast and readability for low vision.": "குறைந்த பார்வைக்காக மாறுபாடு மற்றும் படிக்கும் தன்மையை மேம்படுத்துகிறது.",
  "ADHD Friendly Profile": "ADHD நட்பு சுயவிவரம்",
  "Reduces distractions for better focus.": "சிறந்த கவனத்திற்காக திசைதிருப்பல்களை குறைக்கிறது.",
  "Cognitive & Learning Profile": "அறிவாற்றல் மற்றும் கற்றல் சுயவிவரம்",
  "Helpful tools for reading and comprehension.": "படிப்பு மற்றும் புரிந்துணர்வுக்கு உதவும் கருவிகள்.",
  "Motor Impaired Profile": "மோட்டார் குறைபாட்டு சுயவிவரம்",
  "Optimizes the site for keyboard-only navigation.": "விசைப்பலகை மட்டும் பயன்படுத்தி வழிசலை செய்ய தளத்தை மேம்படுத்துகிறது.",
  "Headings": "தலைப்புகள்",
  "Landmarks": "முக்கியப் புள்ளிகள்",
  "Links": "இணைப்புகள்",
  "Focus element": "உறுப்பை கவனி",
  "Visit link": "இணைப்பை பார்வையிடு"
}